/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
/**
 * Component that creates a 3D Progress Bar cylinder
 */

import React from "react";
import PropTypes from "prop-types";
import Text from "./Text";

function ProgressBar({
    percentage,
    width,
    height,
    fillColor = "#c6c6c6",
    emptyColor = "#c6c6c6",
    fontColor = "#000",
    ...otherAttributes
}) {
    return (
        <a-entity class="ProgressBar" {...otherAttributes}>
            <a-cylinder
                height={width - 0.001}
                radius={height / 2 - 0.001}
                color={emptyColor}
                opacity="0.5"
                rotation="0 0 -90"
            >
                <a-cylinder
                    height={(width / 100) * percentage}
                    radius={height / 2}
                    color={fillColor}
                    position={`0 ${
                        width / -2 + ((width / 100) * percentage) / 2
                    } 0`}
                />
                <Text
                    value={percentage + " %"}
                    align="center"
                    color={fontColor}
                    width={width * 0.2}
                    size="h4"
                    position={`0 0 ${height / 2}`}
                    rotation="0 0 90"
                />
            </a-cylinder>
        </a-entity>
    );
}

ProgressBar.propTypes = {
    percentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default ProgressBar;
